<template>
    <div>
        <form @submit.prevent="submitFiles">
            <div class="dropbox">
                <b-form-file 
                    @change="onFileChange($event)" 
                    :placeholder="$t('Inserir anexos')"
                    :browse-text="$t('Adicionar Arquivos')"
                    multiple                    
                    ref="file-input"
                    class="mb-2"
                    :state="Boolean(files.length)"
                    :file-name-formatter="formatNames"
                    :accept="accept"
                    :id="inputId"
                    v-model="selectFiles"
                ></b-form-file>
            </div>
            <button class="btn btn-success d-none" type="submit" id="btnFormFiles">{{$t('Enviar Anexos')}}</button>
        </form>
        <button v-if="this.files.length > 0 " class="btn btn-light" @click="limparArquivos" >X Limpar</button>
    </div>
</template>

<script>
const TAMANHO_MAXIMO_VIDEO = 20 * 1024 * 1024; // 20MB

export default {
    props: {
        permiteVideo: {
            type: Boolean,
            default: false
        },
        storeModule: {
            type: String,
            default: 'os'
        },
        inputId: {
            type: String,
            default: 'formFiles'
        },
        extensoes: {
            type: Array,
            default: null
        },
        tamanhoMaximo: {
            type: Number,
            default: null
        },
        uploadAction: {
            type: String,
            default: 'os/uploadFiles'
        }
    },
    data() {
        return {
            files: [], // Lista acumulativa de arquivos,
            selectFiles: ''
        };
    },
    computed: {
        accept() {
            return this.extensoes ? this.extensoes.map(extensao => `.${extensao}`).join(',') : ''
        }
    },
    methods: {
        extensaoDe(file) {
            return file.name.split('.').pop().toLowerCase();
        },
        formatNames() {
            return this.files.length === 1 
                ? this.files[0].name 
                : `${this.files.length} arquivos selecionados`;
        },
        isVideo(file) {
            const nome = file.name.toLowerCase();
            return (file.type || '').startsWith('video/')
                || ['.mp4', '.mkv', '.mov', '.avi', '.wmv', '.webm', '.3gp', '.m4v', '.mpeg', '.mpg', '.flv']
                    .some(extensao => nome.endsWith(extensao));
        },
        formatarMb(bytes) {
            return (bytes / (1024 * 1024)).toFixed(1).replace('.', ',');
        },
        onFileChange(event) {
            const newFiles = Array.from(event.target.files);

            // Adicionar novos arquivos, evitando duplicados
            newFiles.forEach(file => {
                if (this.isVideo(file) && !this.permiteVideo) {
                    this.limparArquivos()
                    document.getElementById(this.inputId).value = ''
                    this.$swal.fire({
                        title: this.$t('Oops!'),
                        text: this.$t('Tipo de arquivo não permitido.'),
                        icon: 'error',
                    });
                    return false
                }

                if (this.permiteVideo && this.isVideo(file) && file.size > TAMANHO_MAXIMO_VIDEO) {
                    this.$swal.fire({
                        title: this.$t('Vídeo muito grande'),
                        text: `${file.name} — ${this.formatarMb(file.size)}MB. ${this.$t('O limite para anexos de vídeo é de 20MB. Grave um vídeo mais curto ou reduza a qualidade antes de anexar.')}`,
                        icon: 'warning',
                    });
                    return false
                }
            
                if (this.extensoes && !this.extensoes.includes(this.extensaoDe(file))) {
                    this.$swal.fire({
                        title: this.$t('Oops!'),
                        text: `${this.$t('Extensão não permitida')}: ${this.extensaoDe(file)}`,
                        icon: 'error',
                    });
                    return false
                }

                if (this.tamanhoMaximo && file.size > this.tamanhoMaximo) {
                    this.$swal.fire({
                        title: this.$t('Oops!'),
                        text: `${file.name} — ${this.$t('Arquivo excede o tamanho máximo de')} ${this.formatarMb(this.tamanhoMaximo)}MB`,
                        icon: 'warning',
                    });
                    return false
                }

                if (!this.files.some(existingFile => existingFile.name === file.name && existingFile.size === file.size)) {
                    this.files.push(file);
                }
            });

            this.selectFiles = this.files.length ? [...this.files] : '';

            // Atualizar no Vuex
            this.$store.commit(`${this.storeModule}/setFilesUpload`, this.files);
        },
        limparArquivos(){
            this.files.length = 0
            this.$store.commit(`${this.storeModule}/setFilesUpload`, [])
            this.selectFiles = ''
        },
        submitFiles() {
            if (!this.uploadAction) {
                return
            }

            const formData = new FormData();

            this.files.forEach(file => {
                formData.append('files[]', file);
            });

            this.$store.dispatch(this.uploadAction, {
                data: formData,
                nrSeqOs: this.$route.params.id,
            }).then(response => {
                // Exibir mensagem de sucesso
                // this.$swal.fire({
                //     title: 'Sucesso!',
                //     text: 'Anexos cadastrados com sucesso!',
                //     icon: 'success',
                // });
            }).catch(error => {
                // console.error(error);
                // this.$swal.fire({
                //     title: 'Oops!', 
                //     text: 'Falha ao cadastrar anexos, tente novamente!',
                //     icon: 'error',
                // });
            });
        },
    },
};
</script>

<style>
</style>
